import {createContext, useContext} from 'react'
import {triggerReloadInterface} from '../global'

interface MailingCampaignAnalytics {
  getDataClicks: MailingGetDataClicks;
  countData: MailingCountData;
  chartData: MailingChartData;
  campaignStats: MailingCampaignStats;
}

interface MailingGetDataClicks {
  dataClickUrlMessage: unknown[];
}

interface MailingCountData {
  countCampaigns: number;
  countMessages: number;
  countDataContacts: number;
  lastCampaign: unknown[];
}

interface MailingChartData {
  clicks: MailingMetricData;
  dates: string[];
  delivered: MailingMetricData;
  opens: MailingMetricData;
  queued: MailingMetricData;
  unsubscribers: MailingMetricData;
}

interface MailingMetricData {
  data: number[];
}

interface MailingCampaignStats {
  counts: MailingCounts;
  ratios: MailingRatios;
}

type MailingMetrics = 'open' | 'click' | 'delivered' | 'unsubscrib';

type MailingCounts = Record<MailingMetrics, number>;
type MailingRatios = Record<MailingMetrics, number>;

const initialMailingCampaignAnalytics: MailingCampaignAnalytics = {
  getDataClicks: {
    dataClickUrlMessage: [],
  },
  countData: {
    countCampaigns: 0,
    countMessages: 0,
    countDataContacts: 0,
    lastCampaign: [],
  },
  chartData: {
    dates: [],
    opens: {data: []},
    clicks: {data: []},
    unsubscribers: {data: []},
    queued: {data: []},
    delivered: {data: []},
  },
  campaignStats: {
    counts: {open: 0, click: 0, delivered: 0, unsubscrib: 0},
    ratios: {open: 0, click: 0, delivered: 0, unsubscrib: 0},
  },
}

const MailingContext = createContext<triggerReloadInterface | undefined>(undefined)

const useMailing = () => {
  const context = useContext(MailingContext);
  if (!context) throw new Error('useMailing must be used within MailingProvider');
  return context;
};



export type {
  MailingCampaignAnalytics,
  MailingGetDataClicks,
  MailingCountData,
  MailingChartData,
  MailingMetricData,
  MailingCampaignStats,
  MailingCounts,
  MailingRatios,
}

export {
  initialMailingCampaignAnalytics,
  useMailing,
  MailingContext,
}